import settingsPublicApi from '@/api/settingsPublicApi';
import { useQuery } from '@/hooks/useQuery';

/**
 * The value of a public setting of the service (the admin panel, "Service settings"), FOR-2710.
 * Until the settings are loaded (or when they are not available) the fallback is returned: the value used by the service by default.
 * The request is made once, the answer is cached under one key for all the components of the page.
 */
const usePublicSetting = <T extends number | string | boolean>(key: string, fallback: T): T => {
  const { data } = useQuery(settingsPublicApi.getPublicSettings, { key: 'public-settings' });
  const value = data?.[key];
  return typeof value === typeof fallback && !Number.isNaN(value) ? (value as T) : fallback;
};

export default usePublicSetting;
